import { useEffect, useState } from "react";
import { StandardButton } from "../atoms/buttons"
import { icon } from "../functions/icons"

export const ButtonBar  = ({next, back, style, disabled}) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;
    useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return(

        <div className={`horizontal ${isMobile ? "center" : "flex-end"} assesment-btn-group`} style={style}>
            <StandardButton style={{ width: isMobile ? "100%" : "unset", justifyContent: "center" }} onClick={back} left1={true} backgroundColor="grey-200" textColor="standard-text-color"  className={`${disabled && "disabled"} small-standard-padding go-back-btn`} title={<>{icon("arrow-left")}&nbsp;&nbsp;&nbsp;Terug</>}/>
            <StandardButton style={{ width: isMobile ? "100%" : "unset", justifyContent: "center" }} onClick={next} arrow="no"  className={"small-standard-padding"} title={<>Volgende&nbsp;&nbsp;&nbsp;{icon("arrow-right")}</>}/>
        </div>
    )
}